import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { WrappingSerializer1aufse1qyl29g as WrappingSerializer } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import { MutableReactive2qdhhyljdknhy as MutableReactive } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
  LabelSemantic_getInstance4iffxvo6ijig as LabelSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { textPopover3tarprbgmgxbr as textPopover } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { Renderer1fhwti5gmwutm as Renderer } from './Renderer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerWrapper(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(), WrapperRenderer_instance);
}
var WrapperRendererClass;
function WrapperRenderer() {
  if (WrapperRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Value';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_28tizu_k$(context, module_0) {
        var tmp;
        var tmp_0 = context.serializer_1;
        if (tmp_0 instanceof WrappingSerializer()) {
          tmp = 0.9;
        } else {
          tmp = -1.0;
        }
        return tmp;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_28tizu_k$(context, module_0);
      }
      form_klw3k6_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var wrapper = tmp instanceof WrappingSerializer() ? tmp : THROW_CCE();
        var tmp_0 = wrapper.getDeferred_py8w4r_k$();
        var innerSerializer = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        var innerContext = new (RenderContext())(innerSerializer, context.fieldAnnotations_1);
        var innerRenderer = module_0.select_mv5knr_k$(innerContext);
        var tmp_1 = (it) => wrapper.inner_edgipe_k$(it);
        var innerValue = value.lens_drj4fu_k$(tmp_1, (it) => wrapper.outer_ojvjpq_k$(it));
        return innerRenderer.form_gie6yk_k$(innerContext, isInterface(innerValue, MutableReactive()) ? innerValue : THROW_CCE(), module_0);
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_klw3k6_k$(context, value, module_0);
      }
      view_3m91zp_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var wrapper = tmp instanceof WrappingSerializer() ? tmp : THROW_CCE();
        var tmp_0 = wrapper.getDeferred_py8w4r_k$();
        var innerSerializer = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        var innerContext = new (RenderContext())(innerSerializer, context.fieldAnnotations_1);
        var innerRenderer = module_0.select_mv5knr_k$(innerContext);
        var innerValue = lens(value, (it) => wrapper.inner_edgipe_k$(it));
        return innerRenderer.view_bqdmap_k$(innerContext, innerValue, module_0);
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_3m91zp_k$(context, value, module_0);
      }
      cellView_hcodjr_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var wrapper = tmp instanceof WrappingSerializer() ? tmp : THROW_CCE();
        var tmp_0 = wrapper.getDeferred_py8w4r_k$();
        var innerSerializer = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        var innerContext = new (RenderContext())(innerSerializer, context.fieldAnnotations_1);
        var innerRenderer = module_0.select_mv5knr_k$(innerContext);
        var innerValue = lens(value, (it) => wrapper.inner_edgipe_k$(it));
        return innerRenderer.cellView_2dvin1_k$(innerContext, innerValue, module_0);
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_hcodjr_k$(context, value, module_0);
      }
      cellForm_ks8aws_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var wrapper = tmp instanceof WrappingSerializer() ? tmp : THROW_CCE();
        var tmp_0 = wrapper.getDeferred_py8w4r_k$();
        var innerSerializer = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        var innerContext = new (RenderContext())(innerSerializer, context.fieldAnnotations_1);
        var innerRenderer = module_0.select_mv5knr_k$(innerContext);
        var tmp_1 = (it) => wrapper.inner_edgipe_k$(it);
        var innerValue = value.lens_drj4fu_k$(tmp_1, (it) => wrapper.outer_ojvjpq_k$(it));
        return innerRenderer.cellForm_4mayde_k$(innerContext, isInterface(innerValue, MutableReactive()) ? innerValue : THROW_CCE(), module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_ks8aws_k$(context, value, module_0);
      }
      columnWidth_g6s04q_k$(context, module_0) {
        var tmp = context.serializer_1;
        var wrapper = tmp instanceof WrappingSerializer() ? tmp : THROW_CCE();
        var tmp_0 = wrapper.getDeferred_py8w4r_k$();
        var innerSerializer = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        var innerContext = new (RenderContext())(innerSerializer, context.fieldAnnotations_1);
        return module_0.columnWidth_g5mvjx_k$(innerContext);
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_g6s04q_k$(context, module_0);
      }
      labeledForm_2wlxsw_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          WrapperRenderer_instance.form_klw3k6_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_2wlxsw_k$(context, value, module_0, label, description);
      }
      labeledView_93udid_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          WrapperRenderer_instance.view_3m91zp_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_93udid_k$(context, value, module_0, label, description);
      }
    }
    initMetadataForObject($, 'WrapperRenderer', VOID, VOID, [Renderer()]);
    WrapperRendererClass = $;
  }
  return WrapperRendererClass;
}
var WrapperRenderer_instance;
function WrapperRenderer_getInstance() {
  return WrapperRenderer_instance;
}
//region block: init
WrapperRenderer_instance = new (WrapperRenderer())();
//endregion
//region block: exports
export {
  registerWrapper as registerWrapper35q0amaxu7r44,
};
//endregion

//# sourceMappingURL=WrapperRenderer.mjs.map
